var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"action"},[_c('p',[_vm._v("Boost your links today")]),_c('button',[_vm._v("Get Started")])])])}]

export { render, staticRenderFns }